import React from 'react';
import Head from 'next/head';

const PaymentInstructions = props => {
  return (
    <>
      <Head>
        <title>Card Payment Instruction - WeProdigi</title>
        <link rel="alternate" hrefLang="en" href="https://weprodigi.com/payment-instruction" />
        <meta
          name="description"
          content="Find detailed instructions on how to make payments for Prodigi's services. Follow our step-by-step guide to complete your transaction securely."
        />
      </Head>
      <div className="intro relative w-full h-800 md:h-600   bg-gray-light bg-grid ">
        <div className="relative  h-800 md:h-600 md:flex md:items-center py-12p">
          <div className="container">
            <div className="relative z-10 flex flex-col flex-wrap justify-center items-start h-3/6 md:pb-90 md:mb-120 lg:mb-0 lg:pb-90">
              <h1 className="text-black md:text-green uppercase font-black text-10vw md:text-72 leading-none">
                CARD PAYMENT
                <span className="text-purple md:text-black block">INSTRUCTION</span>
              </h1>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white">
        <div className="container py-30">
          <h2 className="uppercase text-green font-black text-24 md:text-36">Video Instruction</h2>

          <video controls src="https://weprodigi.com/uploads/images/CardPaymentInstruction.mp4" className={'mt-15 mb-15'}></video>

          <h2 className="uppercase text-purple mt-45 font-black text-24 md:text-36">Step-by-step Instruction</h2>

          <h2 className="uppercase text-green font-black text-18 md:text-24">1. CLICK ON THE PAYMENT HYPERLINK</h2>
          <p className="mt-15 text-18">1.1 Click on the payment hyperlink we sent you via email. You will be sent to the window shown below.</p>
          <img className="mt-15" width={'100%'} src="/images/payment/instruction-1.png" alt="instruction-1" />
          <p className="mt-30 text-18">1.2 Click “Pay Now” at the bottom left part of the page.</p>
          <img className="mt-15" width={'100%'} src="/images/payment/instruction-2.png" alt="instruction-2" />
          <h2 className="uppercase text-purple font-black text-18 md:text-24">2. FILL IN THE FIELDS</h2>
          <p className="mt-15 text-18">
            Next, you'll be transferred to the payment system page, where you should fill in your credit card details. Our payment system accepts
            international cards VISA and MasterCard. Double check the information and click "Pay".
          </p>
          <img className="mt-15 max-w-600 mx-auto" width={'100%'} src="/images/dif/screen.webp" alt="screen" />
          <h2 className="uppercase text-purple font-black text-18 md:text-24">3. SUCCESS</h2>
          <p className="mt-15 text-18">After submitting the payment you'll see the confirmed page, as shown below.</p>
          <img className="mt-15" width={'100%'} src="/images/payment/instruction-4.png" alt="instruction-4" />
        </div>
      </div>
    </>
  );
};

export default PaymentInstructions;
